<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import Loading from '@/components/atoms/Loading/index.vue'
import ResultTemplate from '@/components/templates/common/questions/ResultTemplate/index.vue'
import QuestionsResultContent from '@/components/organisms/common/questions/QuestionsResultContent/index.vue'
import { useVueInject } from '@/hooks/vue'
import { QuestionsStoreKey, QuestionsStore } from '@/stores/common/questions'
import { useStates, useActions } from '.'

const router = useRouter()
const store = useVueInject<QuestionsStore>(QuestionsStoreKey)
const states = useStates(store)
const actions = useActions(store, router)

onMounted(async () => {
  if (store.isEmptyInputs()) {
    const route = useRoute()
    store.setInputsByQuery(route.query)
  }
  await store.getResult()
  states.isLoading = false
})
</script>

<template>
  <ResultTemplate :is-shares="states.isShares">
    <Loading :is-loading="states.isLoading" />
    <div>
      <QuestionsResultContent
        :result="store.state.result"
        :category-slug="store.state.inputs.category"
        :restart="actions.restart"
      />
    </div>
  </ResultTemplate>
</template>
